import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import {Ad, PriceType} from "../../interfaces/ad";
import {ApiService} from "../../services/api.service";
import {CreateReport} from "../../interfaces/report";
import {getDummyPicture} from "../../utils/dummyImages";
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { ImageSourcePipe } from '../../pipes/image-source.pipe';

@Component({
    selector: 'kaz-card-report-ad',
    templateUrl: './card-report-ad.component.html',
    styleUrls: ['./card-report-ad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, FaIconComponent, FormsModule, CurrencyPipe, ImageSourcePipe]
})
export class CardReportAdComponent {
    private _api = inject(ApiService);

    showReportAd: boolean = true;
    @Input() ad: Ad | null = null;
    @Output() closeReportAdOnEmit = new EventEmitter();

    report: CreateReport | null = null;

    reportMessage: string = '';
    reportReason: string = '';
    reportList: string[] = [
        'Falsche Kategorie',
        'Irreführung',
        'Unrealistischer Preis',
        'Spam',
        'Verbotener Artikel',
        'Andere Gründe'
    ];

    closeReportAd() {
        this.showReportAd = false;
        this.closeReportAdOnEmit.emit();
    }

    async createReport() {
        try {
            if (this.ad !== null) {
                this.report = {
                    adId: this.ad.id,
                    reason: this.reportReason,
                    message: this.reportMessage,
                };
                const data = await this._api.createReport(this.report);
                this.showReportAd = false;
                this.closeReportAdOnEmit.emit();
            }
        } catch (err) {
            console.log(err);
        }
    }

  protected readonly getDummyPicture = getDummyPicture;
  protected readonly PriceType = PriceType;
}
